// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KO9Ss","right":"styles_right__2ujyc"};